import { trackEvent } from "../analytics";

/**
 * Hook that exposes analytics tracking to components.
 *
 * `trackEvent` is a stable module-level reference, so it is safe to use
 * inside `useEffect` dependency arrays without causing re-renders.
 *
 * @returns Object with a stable `trackEvent` function for capturing analytics events
 *
 * @example
 * ```tsx
 * const { trackEvent } = useAnalytics();
 * trackEvent("dashboard_viewed");
 * ```
 */
export function useAnalytics() {
  return { trackEvent } as const;
}
